module.exports = __webpack_public_path__ + "static/media/4415.885b1679.jpg";